import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../environments/environment';
import {Contact} from '../models/contact.model';
@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor(private http: HttpClient) { }
  getContact(): Observable<any> {
    return this.http.get<any>(`${environment.url}/contact`);
  }

  allContact(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/contact/notReplied`, {'headers': headers});
  }

  saveContact(contact: Contact) {
    return this.http.post<any>(`${environment.url}/contact`, contact);
  }
  getidContact(idA: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/contact/` + idA, {'headers': headers});
  }

  updateContact(contact: Contact) {
    return this.http.put<any>(`${environment.url}/contact/` + contact.id, contact);
  }

  deleteContact(idA: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.delete(`${environment.url}/contact/` + idA, {'headers': headers});
  }

  replyMessage(id: number, message: string): Observable<any>{
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put(`${environment.url}/contact/reply/${id}`, message, {'headers': headers});
  }
}
